import type { ApiRet } from '@spx-portal/shared-types';
import { downloadBlobFile } from '@spx-portal/shared-utils';

import { request } from '@/common/appCtx';

import { BatchImportResData, BatchImportResItem, BatchImportSubmitResData } from './type';

export abstract class ReqManager {
  abstract submitFile(params: any): Promise<any>;
  abstract importFile(params: any): Promise<any>;
  abstract downloadTemplate(): void;
  abstract downloadRes(params: any): Promise<void>;
}

const extractKeyValuePairs = (str: string): Record<string, string> => {
  const regex = /([^=;\s]+)\s*=\s*([^=;\s]+)/g;
  const pairs: Record<string, string> = {};
  let match;

  while ((match = regex.exec(str)) !== null) {
    const key = match[1];
    const value = match[2];
    pairs[key] = value;
  }

  return pairs;
};

const downloadTemplate = async (url: string) => {
  const res = await request.get(url, { responseType: 'blob' }, { shouldReturnAxiosResponse: true });
  const filename: string = extractKeyValuePairs(res.headers['content-disposition']).filename || 'result.xlsx';
  downloadBlobFile(res.data, filename);
};

const createDownloadExistingData = (url: string) => {
  return async (params: { list: BatchImportResItem[] }) => {
    const res = await request.post(url, params, { responseType: 'blob' }, { shouldReturnAxiosResponse: true });
    const filename: string = extractKeyValuePairs(res.headers['content-disposition']).filename || 'result.xlsx';
    downloadBlobFile(res.data, filename);
  };
};

export class CreateReqManager extends ReqManager {
  async submitFile(params : any): Promise<BatchImportSubmitResData> {
    return request
      .post('/api/wfm/admin/workstation/workstation_upload_create_submit', params)
      .then((v: ApiRet) => v.data || {});
  }
  async importFile(params : any): Promise<BatchImportResData<BatchImportResItem>> {
    return request
      .post('/api/wfm/admin/workstation/workstation_upload_create', params)
      .then((v: ApiRet) => v.data || {});
  }
  async downloadTemplate() {
    downloadTemplate('/api/wfm/admin/workstation/workstation_upload_template?operation=Batch Create');
  }
  downloadRes = createDownloadExistingData('/api/wfm/admin/workstation/workstation_upload_create_result_download');
};

export class EditReqManager extends ReqManager {
  async submitFile(params : any): Promise<BatchImportSubmitResData> {
    return request
      .post('/api/wfm/admin/workstation/workstation_upload_update_submit', params)
      .then((v: ApiRet) => v.data);
  }
  async importFile(params : any): Promise<BatchImportResData<BatchImportResItem>> {
    return request
      .post('/api/wfm/admin/workstation/workstation_upload_update', params)
      .then((v: ApiRet) => v.data || {});
  }
  async downloadTemplate() {
    downloadTemplate('/api/wfm/admin/workstation/workstation_upload_template?operation=Batch Edit');
  }
  downloadRes = createDownloadExistingData('/api/wfm/admin/workstation/workstation_upload_update_result_download');
};

export class DeleteReqManager extends ReqManager {
  async submitFile(params : any): Promise<BatchImportSubmitResData> {
    return request
      .post('/api/wfm/admin/workstation/workstation_upload_delete_submit', params)
      .then((v: ApiRet) => v.data);
  }
  async importFile(params : FormData): Promise<BatchImportResData<BatchImportResItem>> {
    return request
      .post('/api/wfm/admin/workstation/workstation_upload_delete', params)
      .then((v: ApiRet) => v.data);
  }
  async downloadTemplate() {
    downloadTemplate('/api/wfm/admin/workstation/workstation_upload_template?operation=Batch Delete');
  }
  downloadRes = createDownloadExistingData('/api/wfm/admin/workstation/workstation_upload_delete_result_download');
};

export class DefaultReqManager extends ReqManager {
  async submitFile() {
    throw Error('No Batch Type');
  }
  async importFile() {
    throw Error('No Batch Type');
  }
  async downloadTemplate() {
    throw Error('No Batch Type');
  }
  async downloadRes() {
    throw Error('No Batch Type');
  }
}
